"use client";

import { FC } from "react";
import { uniqueId } from "lodash";
import Image from "next/image";

import useStateData from "@/hooks/useStateData";
import { AttachedMediaType } from "@/lib/types";

interface ProjectGalleryProps {
  attachedMedia: AttachedMediaType[];
}

const ProjectGallery: FC<ProjectGalleryProps> = ({ attachedMedia }) => {
  const { showProjectModal } = useStateData();

  return (
    <section className="flex flex-no-wrap overflow-x-scroll scrolling-touch items-center my-8 py-4">
      {attachedMedia.map((item) => {
        const scale: number =
          item?.width && item?.height ? item.width / item.height : 1;

        return (
          <div
            key={uniqueId("media")}
            className="flex-none w-2/3 md:w-1/3 hover:scale-105 transition-all ease-out duration-150 cursor-pointer"
            onClick={() => showProjectModal(item)}
          >
            <div
              className="w-11/12 relative  border-1 border-secondary-light dark:border-secondary-dark rounded-xl"
              style={{
                paddingBottom: `min(330px, ${100 / scale}%)`,
              }}
            >
              {item?.sourceUrl && item?.title && (
                <Image
                  className="rounded-xl border-none"
                  src={item.sourceUrl}
                  alt={item.title}
                  layout="fill"
                  objectFit="cover"
                />
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default ProjectGallery;
